<script setup>
import { ref, computed } from "vue"

const props = defineProps({
	item: {
		type: Object,
		required: true,
	},
	baseUrl: {
		type: String,
		default: '/whats-on/'
	}
})

const colourway = computed(() => {
	const brightSparksFound = Array.isArray(props.item.category) && props.item.category.some(
        (cat) => cat.slug === "bright-sparks"
    )
	return brightSparksFound ? "category-sparks" : ""
})

function taxonomyLink( taxonomy ){
	if( props.baseUrl ){
		return `${ props.baseUrl }?${ taxonomy.taxonomy }=${ taxonomy.slug }`
	}else{
		return null
	}
}

</script>

<template>
	<section class="events-list white">
		<article class="tile h-full group flex flex-col gap-4 justify-between text-[--text]" :class="colourway">
			<div class="flex flex-col gap-6">
				<figure class="relative">
					<a :href="item.permalink">
						<img :src="item.img" class="group-hover:opacity-75 aspect-[1.37] object-cover transition" alt="" v-show="item.img" :class="item.img_class" />
						<div class="bg-black opacity-20 aspect-[456/290]" v-show="!item.img"></div>
					</a>
					<span v-if="item.is_visiting" class="group pointer-events-none circle-btn size-[8rem] p-4 hidden md:flex absolute right-4 top-100 -translate-y-1/2 bg-yellow text-black z-10 leading-none">
						<span class="-translate-y-1">Visiting production</span>
					</span>
				</figure>
				<div class="text-sm inline-flex flex-wrap gap-2">
					<span>{{ item.event_date }}</span>
				</div>
				<h3 class="text-md font-bold"><a :href="item.permalink" class="text-[--heading] group-hover:text-[--heading-hover] group-hover:underline decoration-1">{{ item.title }}</a></h3>
				<div class="text-sm inline-flex flex-wrap gap-2">
					<a :href="taxonomyLink( category )" v-for="(category, index) in item.category" :key="category.id" class="underline decoration-1 hover:text-[--text-hover]">{{ category.name }}</a>
				</div>
				<div class="text-sm">
					<p v-html="item.excerpt"></p>
				</div>
			</div>
			<div class="mt-4 border-b-2 border-[--border] flex justify-between items-start">
				<div class="text-sm inline-flex gap-2 items-center">
					<span v-if="item.ages">{{ item.ages }}</span>
				</div>
				<a :href="item.permalink" class="btn bg-[--button-bg] text-[--button-text] hover:bg-[--button-bg-hover] hover:text-[--button-text-hover]">Book now</a>
			</div>
		</article>
	</section>
</template>

<style></style>
